import React, { useState } from 'react';

import { PageHeader, Tooltip } from 'antd';

import styled from 'styled-components';

import { useProjectContext } from '@contexts/ProjectContext';

import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';

import NwIcon from '@components/Gui/NwIcon';
import ProjectTitle from '@components/Project/ProjectTitle';
import SendProjectDrawer from '@components/SendProjectAgendaDrawer/SendProjectDrawer';

import AddProjectEventDropdown from './AddProjectEventDropdown';
import ProjectModelsListDrawer from './ProjectReport/ProjectModelsListDrawer';
import ReportCreationDrawer from './ProjectReport/ReportCreationDrawer';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ProjectHeader = styled.div`
    z-index: 1030;
    top: ${(props) => (props.$isdrawer ? '0' : '80px')};
    width: 100%;
    position: sticky;

    .ant-page-header {
        padding-right: 2.25rem;
        padding-top: 0.5rem;
        margin: ${(props) => (props.$mobileView ? '0 0 1rem 0' : props.$isdrawer ? '0 1rem 1rem 1rem' : '1rem')};
        height: 108px;
        border-bottom: ${(props) => props.theme.DefaultBorder};

        .project-print-button {
            font-size: 1.4rem;
            margin-right: 1rem;
        }
        .project-send-button {
            font-size: 1.4rem;
            margin-right: 1rem;
        }
        .project-addevent-button {
            font-size: 1.4rem;
            margin-right: 1rem;
        }
    }
`;

const ProjectPageHeader = ({ isdrawer }) => {
    const { projectId, projectData: currentProject } = useProjectContext();
    const breakpoints = useNwBreakPoints();
    const [sendProjectDrawer, setSendProjectDrawer] = useState(false);
    const [projectModelsListDrawer, setProjectModelsListDrawer] = useState(false);
    const [printDrawer, setPrintDrawer] = useState(false);
    const [docVersion, setDocVersion] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleShareProject = () => {
        setSendProjectDrawer(true);
    };

    // const handleOpenPrintDrawer = async (templateID) => {
    //     setLoading(true);
    //     setPrintDrawer(true)
    //     const createDocData = {
    //         ProjectID: projectId,
    //         Area: "ProjectReport",
    //         Template: templateID
    //     };
    //     try {
    //         const document = await Axios.post("/projects/printreport", createDocData);
    //         setDocVersion(document)
    //         setLoading(false)
    //     } catch (error) {
    //         console.error('Create Doc Error => ', error);
    //         setLoading(false)
    //     }
    // };

    const handleOpenCreateReportDrawer = () => {
        setPrintDrawer(true);
    };

    const handleOpenProjectModelsListDrawer = () => {
        setProjectModelsListDrawer(true);
    };

    const handleCloseProjectModelsListDrawer = () => {
        setProjectModelsListDrawer(false);
    };

    const handleCloseReportDrawer = () => {
        setPrintDrawer(false);
    };

    return (
        <>
            <ProjectHeader $isdrawer={isdrawer} $mobileView={breakpoints < 4}>
                {currentProject && currentProject.Contact && (
                    <PageHeader
                        title={
                            <div style={{ marginLeft: '1rem' }}>
                                <ProjectTitle project={currentProject} showDepartment allowBookerChange />
                            </div>
                        }
                        extra={[
                            <div key="project-models-list-button" className="project-print-button">
                                <Tooltip title="Create project models list">
                                    <span>
                                        <NwIcon
                                            icon={byPrefixAndName.fasl['file-lines']}
                                            pointer
                                            onClick={handleOpenProjectModelsListDrawer}
                                        />
                                    </span>
                                </Tooltip>
                            </div>,
                            <div key="project-report-button" className="project-print-button">
                                <Tooltip title="Create project report">
                                    <span>
                                        <NwIcon
                                            icon={byPrefixAndName.fasl['file-pdf']}
                                            pointer
                                            onClick={handleOpenCreateReportDrawer}
                                        />
                                    </span>
                                </Tooltip>
                            </div>,
                            <div key="project-send-button" className="project-send-button">
                                <Tooltip title="Send schedule by e-mail">
                                    <span>
                                        <NwIcon
                                            key="share"
                                            icon={byPrefixAndName.fasl['share']}
                                            pointer
                                            onClick={handleShareProject}
                                        />
                                    </span>
                                </Tooltip>
                            </div>,
                            <div key="project-add-event-button" className="project-addevent-button">
                                <AddProjectEventDropdown />
                            </div>,
                        ]}
                        subTitle={false}
                    ></PageHeader>
                )}
            </ProjectHeader>
            {sendProjectDrawer && (
                <SendProjectDrawer currentProject={currentProject} onClose={() => setSendProjectDrawer(false)} />
            )}
            {projectModelsListDrawer && (
                <ProjectModelsListDrawer projectId={projectId} onClose={handleCloseProjectModelsListDrawer} />
            )}
            {printDrawer && <ReportCreationDrawer projectId={projectId} onClose={handleCloseReportDrawer} />}
        </>
    );
};

export default ProjectPageHeader;
